import { PaletteOptions } from '@mui/material';

const PRIMARY_COLOR = '#5513cd';

export const palette: PaletteOptions = {
  mode: 'light',
  primary: {
    main: PRIMARY_COLOR,
  },
  secondary: {
    main: 'rgba(255,255,255,0.87)',
    contrastText: '#000000',
  },
  error: {
    main: '#FF6633',
  },
  warning: {
    main: '#FFCC33',
  },
  info: {
    main: '#CC66CC',
  },
  success: {
    main: '#33CC66',
    contrastText: 'rgba(0,0,0,0.87)',
  },
  grey: {
    50: '#F5F7F9',
    100: '#F7F9FA',
    200: '#F0F3F5',
    300: '#DCE0E3',
    400: '#BEC7CF',
    500: '#959DA3',
    600: '#757E85',
    700: '#475159',
    800: '#2A333A',
    900: '#08131A',
  },
  common: {
    black: '#000000',
    white: '#FFFFFF',
  },
};
